import { get } from "../../pwa/ajax";
import * as BucketTools from "../common/bucket";
import * as Utilities from "../common/utilities";
import * as SessionLogin from "../common/session";
import * as ClearLoQueSigo from './ClearLoQueSigo';
import { preferencias } from '../home/loQueSigo';
import { renderPreferencias, sugerenciasNoSigoNada } from '../nota/preferencias';
import * as Sugerencias from "../nota/sugerencias";
import * as Login from "./login";

const urlBucket = window.config.Statics.BucketUrl;
const urlNavAnonimo = window.config.Statics.ApiNavAnonimaHome;
const urlNavAnonimoExt = window.config.Statics.ApiNavAnonimaExt;

const showErr = console.error.bind(console, "perso ");
const showLog = console.log.bind(console, "perso ");


//TODO: HACER REFACTOR DE ESTE JS, QUEDANDO EN EL MISMO TODO LO DE APIPERSO Y LO DE LOCALSTORAGE, SACAR LO DE PERSO DE LOS OTROS ARCHIVOS, LOQUESIGO, HOME, NOTA, ETC....
//TODO: PODEMOS HACER QUE DESDE SESSION.JS SE LLAME A PERSONALIZACION Y EN EL INICIO YA TENER TODO CARGADO

export const seguirDejarSeguir = (element) => {
    for (let btn of Array.from(element)) {
        btn.addEventListener('click',
            function(event) {

                if (!SessionLogin.init()) {                    
                    let dataPreferible = "{dataPreferibleId}|{dataPreferibleTipoId}"
                        .replace("{dataPreferibleId}",event.currentTarget.getAttribute('data-preferibleId'))
                        .replace("{dataPreferibleTipoId}",event.currentTarget.getAttribute('data-preferibleTipoId'));

                    localStorage.setItem("apiPerso.Pendientes.Preferencias",dataPreferible);

                    location.href = window.config.Statics.LoginUrl + window.btoa(location.href);
                    return;
                }

                const apiPerso = SessionLogin.initPerso();

                if (event.currentTarget.classList.contains("activo")) {
                    event.currentTarget.classList.remove("activo");
                    event.currentTarget.innerText = "SEGUIR";
                    apiPerso.preferencias.dejarDeSeguirPreferible(
                        event.currentTarget.getAttribute('data-preferibleId'),
                        event.currentTarget.getAttribute('data-preferibleTipoId'));
                    apiPerso.execute()
                        .then(resp => { 
                            dejarSeguirOrSeguir();
                        })
                        .catch(console.log.bind(console, 'error'));                    

                } else {
                    event.currentTarget.classList.add("activo");
                    event.currentTarget.innerText = "SIGUIENDO";
                    apiPerso.preferencias.seguirPreferible(event.currentTarget.getAttribute('data-preferibleId'),
                        event.currentTarget.getAttribute('data-preferibleTipoId'));
                    apiPerso.execute()
                        .then(resp => {  
                            dejarSeguirOrSeguir();
                        })
                        .catch(console.log.bind(console, 'error'));
                }
            });
    }
}

const dejarSeguirOrSeguir = () => {

    const apiPerso = SessionLogin.initPerso();

    if (!SessionLogin.init()) {
        location.href = window.config.Statics.LoginUrl + window.btoa(location.href);
        return;
    }     
    
    apiPerso.execute()
        .then(resp => {  
            ClearLoQueSigo.clearLS();          
        })                    
        .catch(console.log.bind(console, 'error'));    
}



export const preferenciasPendientes = () => {
    let preferenciasPendientes = localStorage.getItem("apiPerso.Pendientes.Preferencias");

    if(preferenciasPendientes != null)
    {
        const apiPerso = SessionLogin.initPerso();
        let datosPreferencias = preferenciasPendientes.split("|");

        apiPerso.preferencias.seguirPreferible(
            parseInt(datosPreferencias[0]),
            parseInt(datosPreferencias[1]));

        apiPerso
            .execute()
            .then(resp => {                
                localStorage.removeItem("apiPerso.Pendientes.Preferencias");
            })
            .catch(showErr.bind(console, "execute"));
    }
}

export const dejarSeguirLoQueSigo = (element) => {

    const apiPerso = SessionLogin.initPerso();

    for (let btn of Array.from(element)) {
        btn.addEventListener('click',
            function(event) {

                if (!SessionLogin.init()) {
                    location.href = window.config.Statics.LoginUrl + window.btoa(location.href);
                    return;
                }                

                apiPerso.preferencias.dejarDeSeguirPreferible(
                    event.currentTarget.getAttribute('data-preferibleId'),
                    event.currentTarget.getAttribute('data-preferibleTipoId'));
                apiPerso.execute()
                    .then(resp => {
                        ClearLoQueSigo.clearLS();
                    })                    
                    .catch(console.log.bind(console, 'error'));
                 
                event.currentTarget.parentNode.remove();
            });
    }
}

//////////////////
//  LO QUE SIGO //
//////////////////
export const initPreferencias = (section = "") => {
    debugger;
    let fechaGeneracionHomeMilliseconds = "";
    let fechaGeneracionHomeLs = "";

    const ctx = null;
    if (SessionLogin.init()) {
        //let obtenerSugerencias = localStorage.getItem("obtenerSugerencias");
        let obtenerHashSuscripciones = localStorage.getItem("obtenerHashSuscripciones");
        let obtenerPreferibles = localStorage.getItem("obtenerPreferibles");
        let obtenerPorPrioridad = localStorage.getItem("obtenerPorPrioridad");
        let recomendarTemas = localStorage.getItem("recomendarTemas");

        if (section === "home" ) {
            fechaGeneracionHomeMilliseconds = new Date(document.querySelector("#fechaGeneracionHome").getAttribute("value")).getTime();
            const fechaGeneracionLs = localStorage.getItem("fechaGeneracionHome");
            fechaGeneracionHomeLs = fechaGeneracionLs === null ? 0 : parseInt(fechaGeneracionLs);

            if (fechaGeneracionHomeMilliseconds > fechaGeneracionHomeLs) {
                localStorage.setItem("fechaGeneracionHome", fechaGeneracionHomeMilliseconds);
                obtenerHashSuscripciones = null;
                obtenerPreferibles = null;
                obtenerPorPrioridad = null;
                recomendarTemas = null;
            }
        }

        const apiPerso = SessionLogin.initPerso();
        preferenciasPendientes();

        if (section === "nota") {
            const obtenerNotaId = document.querySelector("div[data-notaId]").getAttribute("data-notaId");
            const obtenerTemas = document.querySelector("div[data-preferibles]").getAttribute("data-preferibles")
                .split(",");
            apiPerso.sugerencias.lecturaNota(obtenerNotaId)
                .then(resp => {
                    showLog.bind(console, 'lecturaNota');
                })
                .catch(showErr.bind(console, 'lecturaNota'));

            apiPerso.sugerencias.registrarTemas(obtenerTemas, ctx)
                .then(showLog.bind(console, 'registrarTemas'))
                .catch(showErr.bind(console, 'registrarTemas'));

            apiPerso.preferencias.obtenerNovedades()
                .then(resp => {
                    localStorage.setItem("obtenerNovedades", resp[0].cantidad);
                });

            if (localStorage.getItem("obtenerNovedades") !== null && parseInt(localStorage.getItem("obtenerNovedades")) > 0) {
                //Obtener las Preferencias y competando con sugerencias llegado el caso.
                apiPerso.comunes.obtenerPorPrioridad(true, 32, "Preferencia", [], [], [], true, [], ["home-instanciada"])
                    .then(resp => {
                        localStorage.setItem("obtenerPorPrioridad", JSON.stringify(resp));
                        obtenerPorPrioridad = localStorage.getItem("obtenerPorPrioridad");
                    });
            }
        }

        if (obtenerHashSuscripciones === null) {
            apiPerso.preferencias.obtenerHashSuscripciones()
                .then(resp => {
                    localStorage.setItem("obtenerHashSuscripciones", resp);
                    obtenerHashSuscripciones = localStorage.getItem("obtenerHashSuscripciones");
                })
                .catch(showErr.bind(console, "Obtener hash suscripciones"));
        }

        if (obtenerPorPrioridad === null) {
            //const idsExcluidos = localStorage.getItem("notasUltimasNoticias").split(",").map(n => parseInt(n));
            apiPerso.comunes.obtenerPorPrioridad(true, 32, "Preferencia", [], [], [], true, [], ["home-instanciada"])
                .then(resp => {
                    if (section === "home") {
                        const notasLimpias = limpiarPerferenciasDeUltimasNoticias(localStorage.getItem("notasUltimasNoticias"), resp);
                        localStorage.setItem("obtenerPorPrioridad", JSON.stringify(notasLimpias));
                        return;
                    }
                    localStorage.setItem("obtenerPorPrioridad", JSON.stringify(resp));
                    obtenerPorPrioridad = localStorage.getItem("obtenerPorPrioridad");
                });
        }

        if (obtenerPreferibles === null) {
            apiPerso.preferencias.obtenerPreferibles()
                .then(resp => {
                    localStorage.setItem("obtenerPreferibles", JSON.stringify(resp));
                    obtenerPreferibles = localStorage.getItem("obtenerPreferibles");
                })
                .catch(showErr.bind(console, "Obtener preferibles"));
        }
        
        if (recomendarTemas === null) {
            //Para temas y autores mas sugeridos
            apiPerso.sugerencias.recomendarTemas(5)
                .then(resp => {
                    localStorage.setItem("recomendarTemas", JSON.stringify(resp));
                    recomendarTemas = localStorage.getItem("recomendarTemas");
                });    
        }

        apiPerso.execute()
            .then(resp => {
                cargarLsPreferenciasTemasYSugerencias(section);
            })
            .catch(showErr.bind(console, "execute"));
        
    } else {
        if (section === "home") {
            preferencias();
        } else {
            //NO LOGUEADO 
            getDataNoLogueado();
            if (isSessionDateExpired()) {
                reLoadSugerenciasAnonimas();
            }    
        }
    }
}

const limpiarPerferenciasDeUltimasNoticias = (notasUltimasNoticias, notasPreferencias) => {
    if (!notasUltimasNoticias)
        return limpiarPreferenciasDeColumnistas(notasPreferencias);

    notasUltimasNoticias = notasUltimasNoticias.split(",");
    const arrayIdsUltimasNoticias = notasUltimasNoticias.map(i => parseInt(i));
    const arrayIdsPreferencias = notasPreferencias.map(n => n.contenido_id);
    const arrayIdsParaBorrar = arrayIdsPreferencias.filter(val => arrayIdsUltimasNoticias.includes(val));
   
    //retorna un nuevo array con los valores que NO ESTEN EN AMBOS (o sea los que no coinciden en ambos arrays)
    const preferencias = notasPreferencias.filter(x => arrayIdsParaBorrar.indexOf(x.contenido_id) === -1);

    return limpiarPreferenciasDeColumnistas(preferencias);
}

const limpiarPreferenciasDeColumnistas = (preferencias) => {
    const notasIdsTotal = [];
    //Editoriales
    const notasEditoriales = document.querySelectorAll("section#autores > section.editoriales > article");
    //Columnistas
    const notasColumnistas = document.querySelectorAll("section#autores > article.autor");

    notasEditoriales.forEach((item) => {
        notasIdsTotal.push(parseInt(item.getAttribute("data-notaid")));
    });
    
    notasColumnistas.forEach((item) => {
        notasIdsTotal.push(parseInt(item.getAttribute("data-notaid")));
    });

    return preferencias.filter(x => notasIdsTotal.indexOf(x.contenido_id) === -1);
}

const cargarLsPreferenciasTemasYSugerencias = (section) => {
    const apiPerso = SessionLogin.initPerso();
    let obtenerNovedades = localStorage.getItem("obtenerNovedades");
    let obtenerSugerencias = localStorage.getItem("obtenerSugerencias");

    if (localStorage.getItem("obtenerHashSuscripciones") !== null) {
        //Obtener las Preferencias y competando con sugerencias llegado el caso.
        if (section === "nota")  {
            if (obtenerSugerencias === null) {
                const objResult = Sugerencias.getValoresDeCorte();
                //const jsonCategoria = JSON.parse(localStorage.getItem("obtenerPreferibles"));

                apiPerso.sugerencias.obtener([], 25, objResult.horas, objResult.dias, objResult.usuario, objResult.categorias)
                    .then(resp => {
                        localStorage.setItem("obtenerSugerencias", JSON.stringify(resp));
                        obtenerSugerencias = localStorage.getItem("obtenerSugerencias");
                    })
                    .catch(showErr.bind(console, "obtener sugerencias"));
            }
        }

        if (obtenerNovedades === null) {
            apiPerso.preferencias.obtenerNovedades()
                .then(resp => {
                    localStorage.setItem("obtenerNovedades", resp[0].cantidad);
                    obtenerNovedades = localStorage.getItem("obtenerNovedades");
                });    
        }

    } else { //SIN PREFERENCIAS
        if (recomendarTemas === null) {
            //Para temas y autores mas sugeridos
            apiPerso.sugerencias.recomendarTemas(5)
                .then(resp => {
                    localStorage.setItem("recomendarTemas", JSON.stringify(resp));
                    recomendarTemas = localStorage.getItem("recomendarTemas");
                });
        }
    }

    apiPerso.execute()
        .then(resp => {
            if (section === "home") {
                preferencias();
            } else {
                if (localStorage.getItem("obtenerHashSuscripciones") !== null) {
                    renderPreferencias();
                    Sugerencias.sugerencias();
                } else { //SIN PREFERENCIAS
                    sugerenciasNoSigoNada();
                }
            }
            preferenciasCambioBotonSiguiendo();
        })
        .catch(showErr.bind(console, "execute"));
}

const isSessionDateExpired = () => {
    const createdDate = localStorage.getItem("sugerenciasNoLoginCreated");
    let cacheMiliseconds = 300000; ///TODO:pasar a configuracion
    let dif = 0;

    if (createdDate === null) {
        return true;
    } else {
        dif = Date.now() - createdDate;
        if (dif < cacheMiliseconds) {
            return false;
        } else {
            return true;
        }
    }
}

const reLoadSugerenciasAnonimas = () => {

    localStorage.removeItem("sugerenciasNoLogin");
    getDataNoLogueado();

}

export const preferenciasCambioBotonSiguiendo = () => {
    //TODO: Refactor ver donde se puede hacer esta llamada una sola vez para reutilizacion inicial de todas las pag
    let LSPreferible = localStorage.getItem("obtenerPreferibles");    
    
    if (!SessionLogin.init()) { return; }

    if (LSPreferible === null) {

        const apiPerso = SessionLogin.initPerso();

        apiPerso.preferencias.obtenerPreferibles()
            .then(resp => {
                localStorage.setItem("obtenerPreferibles", JSON.stringify(resp));                                    
            })
            .catch(showErr.bind(console, "Obtener preferibles"));

        apiPerso
            .execute()
            .then(resp => {
                cambioBotonSiguiendo();
            })
            .catch(showErr.bind(console, "execute"));   

    }
    else{
        cambioBotonSiguiendo();
    }
}

const cambioBotonSiguiendo = () => {
    let LSPreferible = localStorage.getItem("obtenerPreferibles");
    if (LSPreferible == null) return;

    let dataPreferibles = JSON.parse(LSPreferible);
    let idsPreferibles = [];
    document.querySelectorAll('button.seguir').forEach(function(elem) {
        idsPreferibles.push(elem.getAttribute('data-preferibleid'));
    });

    for (var preferible of dataPreferibles) {
        if (idsPreferibles.indexOf(preferible.id.toString()) != -1) {
            let nodo = document.querySelectorAll('button.seguir[data-preferibleid="' + preferible.id + '"]');            
            
            nodo.forEach(function(element, index) {
                element.textContent = 'SIGUIENDO';
                element.classList.add('activo');
            });
            
        }
    }
}

const getDataNoLogueado = () => {
    let resp;   
    let sugerenciasNoLoginLS = localStorage.getItem("sugerenciasNoLogin");

    if(sugerenciasNoLoginLS != null) {
        renderNoLogueado(JSON.parse(sugerenciasNoLoginLS));
        sugerenciasNoLoginLS = purgarNotaDeSugerenciasNoLogueado(JSON.parse(sugerenciasNoLoginLS));
        sugerenciasNoLogin(sugerenciasNoLoginLS);
    } else {
        if(randomFn() > 5) {
            get(urlNavAnonimo)
                .then(rs => {  
                    localStorage.setItem("sugerenciasNoLogin",rs);
                    localStorage.setItem("sugerenciasOrigen","home");
                    localStorage.setItem("sugerenciasNoLoginCreated",Date.now());
                    renderNoLogueado(JSON.parse(rs));
                    resp = purgarNotaDeSugerenciasNoLogueado(JSON.parse(rs));
                    sugerenciasNoLogin(resp);
                });
        } else {
            get(urlNavAnonimoExt)
                .then(rs => {        
                    localStorage.setItem("sugerenciasNoLogin",rs);
                    localStorage.setItem("sugerenciasOrigen","nohome");
                    localStorage.setItem("sugerenciasNoLoginCreated",Date.now());
                    renderNoLogueado(JSON.parse(rs));
                    resp = purgarNotaDeSugerenciasNoLogueado(JSON.parse(rs));
                    sugerenciasNoLogin(resp);
                });
        }        
    }
}

const purgarNotaDeSugerenciasNoLogueado = (notas) => {
    const notaId = document.querySelector("div[data-notaId]").getAttribute("data-notaId");
    let notasSugerencias = notas.items;
    
    if (notasSugerencias !== null && notasSugerencias !== undefined && notasSugerencias.length > 0) {
        notasSugerencias.forEach((laNota, index) => {
            if (laNota.id === parseInt(notaId)) {
                notasSugerencias.splice(index, 1);
            }
        });
    }
    return notasSugerencias;
}

const randomFn = () => {
    return Math.floor((Math.random() * 10) + 1);
}

const renderNoLogueado = (notas) => {
    if (document.querySelector("#bloque-2")) {
        const notasTemasRecomendados = notas.items.filter(nota => nota.tagDestacado);
        const css = "sin-loguear";
        let html = "";

        if (notasTemasRecomendados !== null &&
            notasTemasRecomendados !== undefined &&
            notasTemasRecomendados.length > 0) {
            const valueToSlice = notasTemasRecomendados.length < 3 ? notasTemasRecomendados.length : 3;

            html += `<div class="techo floatFix">
                    <h4>REGISTRATE EN LA NACION Y </h4>
                    <h4><b>MEJORÁ TU EXPERIENCIA</b></h4>
                    <button class="ingresar"> INGRESÁ </button>
                </div>
                <p>Seguí los temas y autores que más te interesan y enterate, al instante, cada vez que haya nuevas notas</p>
                <section class="mas-seguidos">`;

            for (let nota of notasTemasRecomendados.slice(0, valueToSlice)) {
                const id = nota.tagDestacado.id;                    

                html += `<div class="tema floatFix"><p>${nota.tagDestacado.valor}</p>
                     <button class="seguir" data-preferibleId="${id}" data-preferibleTipoId="7">SEGUIR</button></div>`;
            }
            html += `</section>`;
        }

        const asideBloque2 = document.querySelector("#bloque-2");
        asideBloque2.classList.add(css);
        asideBloque2.innerHTML = html;

        Login.Initialize();
    }
    seguirDejarSeguir(document.querySelectorAll('button[class="seguir"]'));
}

const sugerenciasNoLogin = (notas) => {
    if (notas != null && notas.length > 0) { 
        
        notas = notas.filter(item => item != null && item.imagenes !== null && item.imagenes !== undefined && item.imagenes.length > 0);        
        
        let notasBloque1 = notas.slice(0, 7);
        let notasBloque2 = notas.slice(7, 15);
        let notasBloque3 = notas.slice(15, 20);
        let contador = 0;
        let toi = 101;

        let html = `<section class="puede-interesar" id="bloque-3" data-is-block="true" data-block-name="n_sugerencias" data-diagramacion-id="0">
                    <div class="fila-1 floatFix" id="sugeridasBloque3F1">
                    <h4>Te puede interesar</h4>
                    <div class="columna-doble">${getArticleSugeridoSinLogin(notas[0], 514,137,toi)}</div>`;
    
        let article = "";
        notasBloque1.shift();
        for (var nota of notasBloque1) {
            toi++;
            article += getArticleSugeridoSinLogin(nota, 216,137,toi);
            contador++;
            
            if (contador % 2 === 0) {
                html += `<div class="columna">${article}</div>`;
                article = "";
            }
        }
        html += "</div>";        

        if(notasBloque2.length == 7)
        {
            html += `<div class="fila-2 floatFix" id="sugeridasBloque3F2">`;
            article = "";
            contador = 0;
            for (var nota of notasBloque2) {
                toi++;
                article += getArticleSugeridoSinLogin(nota, 216,137,toi);
                contador++;
                if (contador % 2 === 0) {
                    html += `<div class="columna">${article}</div>`;
                    article = "";
                }
                if (contador === 5) {
                    toi++;
                    article = getArticleSugeridoSinLogin(nota, 514,137,toi);
                    html += `<div class="columna-doble">${article}</div>`;
                    article = "";
                    contador++;
                }
            }
            html += `</div>`;
        }
        
        if(notasBloque3.length == 5)
        {
            html += `<div class="fila-3 floatFix" id="sugeridasBloque3F3">`;
            for (var nota of notasBloque3) {
                toi++;
                html += getArticleSugeridoSinLogin(nota, 216,137,toi);
            }
            html += `</div></section>`;
        }        
        
        html += `</aside>`;
        document.querySelector('div[data-module="nota-sugeridas"]').innerHTML = html; 
    }
}

const getArticleSugeridoSinLogin = (nota, width,widthTablet,toi) => {
    let imgHtml = "";
    let toiPos = "toi".concat(toi.toString());
    let sugerenciasOrigen = localStorage.getItem("sugerenciasOrigen");
    if (nota.imagenes instanceof Array && nota.imagenes[0].src != null && nota.imagenes[0].src != "") {
        imgHtml += `<source media="(min-width: 768px)" srcset="${BucketTools.urlBucketBalance(urlBucket, nota.imagenes[0].src, "", width)}">`;
        imgHtml += `<img src="${BucketTools.urlBucketBalance(urlBucket, nota.imagenes[0].src, "", widthTablet)}"/>`;
    }
    let html = `<article title="" class="nota" data-id="${nota.id}" data-notaid="${nota.id}" data-source="ranking-ref-${sugerenciasOrigen}" data-pos="${toiPos}">
                  <a class="figure" href="${Utilities.FormatearUrl(nota.url)}">
                      <picture>
                        ${imgHtml}
                      </picture>
                  </a>
                  <h2><a href="${Utilities.FormatearUrl(nota.url)}">${nota.titulo}</a></h2>
                </article>`;
    return html;    
}

export const registrarAccesosAcumulados = () => {
    if (SessionLogin.init()) {
        const apiPerso = SessionLogin.initPerso();

        const preferibleAcumulado = document.querySelector('div[data-preferibles]').getAttribute('data-preferibles');
        const ctx = null;
        apiPerso.sugerencias
            .registrarAccesos(preferibleAcumulado, ctx)
            .then(console.log.bind(console, 'registrarAccesos'))
            .catch(console.log.bind(console, 'registrarAccesos'));
        apiPerso.execute()
            .then(console.log.bind(console, 'execute '))
            .catch(console.log.bind(console, 'error'));
    }
}




// WEBPACK FOOTER //
// ./Statics/scripts/common/personalizacion.js